.root {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.root[data-disabled] {
  pointer-events: none;
}

.sliderContainer {
  display: flex;
  flex: 1;
  padding: 0 0.375rem;
  margin-right: -0.375rem;
}

.root[data-disabled] > .sliderContainer {
  opacity: 0.5; /* edit button is itself disabled, so don't fade it more */
}

.popupOuter {
  position: absolute;
  z-index: 2; /* above other floating elements (overflow menu, selectors, etc.) */
  bottom: 1px; /* guarantees overlap with toolbar so the popup doesn't close when the pointer moves into it */
  padding-top: 6px; /* matches other floating elements */
  transform: translateY(100%);
  /* Add invisible padding around popup to extend hover area */
  /* (especially for when enabling auto-scaling hides an error message). */
  padding-left: 2rem;
  padding-right: 2rem;
  padding-bottom: 2rem;
}

.popup {
  composes: popup from '../../utils.module.css';
  display: flex;
  align-items: center;
  padding: 1rem 0.375rem 1rem 0.75rem;
  background-color: var(
    --h5w-domainWidget-popup--bgColor,
    var(--h5w-toolbar-popup--bgColor, rgba(255, 255, 255, 0.9))
  );
}
